var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <div class=\"web-component-bg\"> <div class=\"web-component-center\"> <div class=\"search-wrapper-selector\"> <div class=\"search-option search-month\"> <select ng-model=\"$ctrl.firstMonth\" ng-options=\"month.name for month in $ctrl.cachedMonths track by month.id\"></select> </div> <div ng-click=\"$ctrl.goToPage()\" class=\"search-option search-btn\"> </div> </div> </div> </div> </web-component>";
var id1="winresDeparturesCalendarSelector.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDeparturesCalendar/winresDeparturesCalendarSelector.html
// module id = 367
// module chunks = 2